import {
	whenReady,
	getViewControllerName,
	getMetaContent
} from '../general/Util';
import MiniBasket from './../libs/MiniBasket.js';


class StylesAndLooks {

	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.refresh();
	}

	refresh() {
		const articleEls = Array.from( this.containerEl.querySelectorAll( '.mdl_article_preview' ) );
		this.articles = articleEls.map( articleEl => {
			articleEl.ACL_STYLES_AND_LOOKS_ARTICLE ??= new StylesAndLooksArticle( articleEl );
			return articleEl.ACL_STYLES_AND_LOOKS_ARTICLE;
		} );
	}

	setTotalOutfitPrice = () => {

		// Deprecated.
		return;
		/*
                var p = $("input[id^='price_" + productid + "']");
                var price = p.val();
                var totalprice = $('#totalsum').val();
                $('#totalsum').val(parseFloat(totalprice) + parseFloat(price));
                $('#totalsum').trigger('change');
                p.closest('.mdl_article_preview').addClass('active');
        */
	};

	addOutfitToBasket = () => {

		// Deprecated.
		return;
		/*
                var form = $('#' + formid);
                var selecteditems = $("input.setitem_" + productid);
                selecteditems.each(function () {
                    if ($(this).val() == '1') {
                        var itemid = $(this).attr('id').split('_')[4];
                        //console.debug('found item: ' + itemid);
                        form.append('<input type="hidden" name="aproducts[' + itemid + '][anid]" value="' + itemid + '"/>');
                        form.append('<input type="hidden" name="aproducts[' + itemid + '][aid]" value="' + itemid + '"/>');
                        form.append('<input type="hidden" name="aproducts[' + itemid + '][am]" value="1"/>');
                    }
                });
                form.submit();
        */
	};
}

class StylesAndLooksArticle {

	constructor( articleEl ) {

		this.articleEl = articleEl;
		this.productId = articleEl.dataset.product;

		// Get all Inputs and make them easily accessible.
		this.colorEls = Array.from( articleEl.querySelectorAll( '.color' ) );
		this.labelEls = Array.from( articleEl.querySelectorAll( '.colorlabel' ) );
		this.itemEls = Array.from( articleEl.querySelectorAll( 'input.setitem' ) );
		this.selectEl = articleEl.querySelector( '.item-size-dropdown' );
		this.buttonEl = articleEl.querySelector( '.shop_the_look_add' );
		this.imageEl = articleEl.querySelector( 'img.article_image' );
		this.popupEl = articleEl.querySelector( '.mdl_popup' );

		// Copy select options for colorchange logic.
		this.allOptionEls = [];
		if ( this.selectEl ) {
			this.allOptionEls = Array.from( this.selectEl.options ).map( optionEl => optionEl.cloneNode( true ) );
		}

		// Add Event Listeners.
		this.colorEls.forEach( colorEl => colorEl.addEventListener( 'change', ( evt ) => this.onColorChange( evt ) ) );
		this.selectEl && this.selectEl.addEventListener( 'change', ( evt ) => this.onSizesChange( evt ) );

		// Switch Image on Hover.
		this.labelEls.forEach( labelEl => {
			labelEl.addEventListener( 'mouseenter', () => this.onHover( labelEl ) );
			labelEl.addEventListener( 'mouseleave', () => this.onHover() );
		} );

		// Add to Basket.
		this.buttonEl && this.buttonEl.addEventListener( 'click', () => this.addToBasket() );

		// Initialise all values.
		this.setSelect();
		this.setImage();
		this.setPrice();
		this.setSoldOut();
		this.setResult();
	};

	/**
     * Get the currently selected size.
     */
	getSize = () => {
		return this.selectEl?.value;
	};

	/**
     * Get the currently selected Color.
     */
	getColor = () => {
		if ( this.colorEls.length <= 0 ) {
			return this.articleEl.querySelector( 'input.setitem' ).dataset.color;
		} else {
			return this.colorEls.find( ( colorEl ) => colorEl.checked )?.value;
		}
	};

	/**
     * Get the Price of the current article.
     */
	getPrice = () => {
		const priceInputEl = document.getElementById( 'price_' + this.productId );
		return parseFloat( priceInputEl.value || 0 );
	};

	/**
     * updates the input price of the current article.
     */
	updatePrice = ( newPrice ) => {
		const priceInputEl = document.getElementById( 'price_' + this.productId );
		priceInputEl.value = parseFloat( newPrice || 0 );
	}

	/**
     * Get Current Style Input.
     * Uses one of the hidden input fields, which are used to add to basket.
     */
	getArticleItem = () => {

		const currentColor = this.getColor();
		const selectedSize = this.getSize();

		// Get current article variant by
		return this.itemEls.find( ( itemEl ) => {

			// Get matches for color and size.
			const colorMatches = currentColor && itemEl.dataset.color === currentColor;
			const sizeMatches  = selectedSize && String( itemEl.dataset.size ) === String( selectedSize );

			// If the Size Select does not exist, or its not visible there is only one size and we match by color only.
			if ( this.selectEl && this.selectEl.classList.contains( 'with-nosize' ) ) {
				return colorMatches;
			}

			// If the Size Select is visible, we use size + color.
			return colorMatches && sizeMatches;
		} );
	};

	onHover = ( labelEl = null ) => {
		if ( labelEl ) {
			this.setImage( '#' + labelEl.getAttribute( 'for' ) );
			this.setPrice( labelEl.getAttribute( 'for' ) );
			this.setSoldOut( labelEl.getAttribute( 'for' ) );
		} else {
			this.setImage();
			this.setPrice();
			this.setSoldOut();
		}
	}

	/**
     * Handle change of the color inputs.
     */
	onColorChange = () => {
		// Change Sizes in Sizeselect.
		this.setSelect();

		// Also change Image if the variant changes.
		this.setImage();

		// change the price of the variant
		this.setPrice();

		// Set SoldOut Labels.
		this.setSoldOut();

		// Finally, update ButtonHtml and Link.
		this.setResult();
	};

	/**
     * Handle change of the size select.
     */
	onSizesChange = () => {

		// change the price of the variant
		this.setPrice();

		// Set SoldOut Labels.
		this.setSoldOut();

		// Update ButtonHtml and Link.
		this.setResult();
	};

	setSoldOut = ( colorid = null ) => {
		const currentItemEl = this.getItemByColorId( colorid );
		if ( ! currentItemEl ) {
			return false;
		}

		const stock = parseInt( currentItemEl.dataset.stock || 0 );
		const hasStock = stock > 0;
		const badgeEl = this.articleEl.querySelector( '.article_soldout_badge' );

		this.articleEl.classList.toggle( 'style_sold_out', !hasStock );
		badgeEl.classList.toggle( 'en_hidden', hasStock );
	};

	/**
     * Set Select values.
     * Hide values that are not possible with the current color.
     */
	setSelect = () => {

		// Return if no select to set.
		if ( ! this.selectEl ) {
			return this;
		}

		const currentColor = this.getColor();
		const selectedSize = this.getSize();

		// Generate Options for the Size Select.
		const newOptionEls = this.allOptionEls.filter( ( optionEl ) => {
			return optionEl.dataset.color === currentColor || '' === optionEl.value;
		} ).map( optionEl => {
			const newNode = optionEl.cloneNode( true );
			newNode.style.display = '';
			return newNode;
		} );

		// Add new options and set new index.
		this.selectEl.replaceChildren( ...newOptionEls );
		this.selectEl.value = selectedSize;

		// Set to nosize, if it is in the settings.
		if ( newOptionEls.some( optionEl => 'nosize' === optionEl.value ) ) {
			this.selectEl.value = 'nosize';
		}

		// Remove value if the previously selected index is sold-out.
		if ( this.selectEl.options[ this.selectEl.selectedIndex ]?.disabled ) {
			this.selectEl.value = '';
		}

		return this;
	};

	/**
     * Set Image based on the current color.
     */
	setImage = ( color = null ) => {
		const imageEl = this.imageEl;
		const colorEl = this.colorEls.find( colorEl => color ? colorEl.matches( color ) : colorEl.checked );
		const linkEls = this.articleEl.querySelectorAll( '.style-thumb-link, .article_name' );

		// Return if no color found.
		if ( ! colorEl ) {
			return this;
		}

		const basePath = this.articleEl.querySelector( '.originalimagepath' )?.value ?? '';
		const defaultPath = this.articleEl.querySelector( '.originalimage' )?.value ?? '';

		// Get custom Image File if available.
		const picInputEl = document.getElementById( colorEl.getAttribute( 'data-picid' ) );
		const imageFile = picInputEl ? picInputEl.value : defaultPath;

		// Set new Image src.
		imageEl.src = basePath + imageFile;

		if ( this.itemEls.length > 0 ) {

			let articlenumber = imageFile.replace( '.webp', '' );
			articlenumber = articlenumber.replace( '.jpg', '' );
			articlenumber = articlenumber.replace( /_.*$/, '' );

			linkEls.forEach( linkEl => {
				const currentHref = linkEl.getAttribute( 'href' );
				if ( articlenumber ) {
					const newHref = currentHref.replace( /\d+\.html$/, articlenumber + '.html' );
					linkEl.setAttribute( 'href', newHref );
				}
			} );
		}
		return this;
	};


	getItemByColorId( colorid = null ) {

		// If no color is preferred, we try to return the currently selected item.
		if ( ! colorid ) {
			const articleItem = this.getArticleItem();
			if ( articleItem ) {
				return articleItem;
			}
		}

		// Could be, we have no size selected, load first available size of matching color.
		let colorItemEls = ( () => {
			if ( ! colorid ) {
				const selectedColor = this.getColor();
				return this.itemEls.filter( itemEl => itemEl.dataset.color === selectedColor );
			} else {
				return Array.from( this.articleEl.querySelectorAll( '.setitem[data-acl-style-identifier="' + colorid + '"]' ) );
			}
		} )();

		// Filter by selected size, if available and there are results.
		const selectedSize = this.getSize();
		if ( selectedSize ) {
			const filteredBySize = colorItemEls.filter( itemEl => itemEl.dataset.size === selectedSize );
			if ( filteredBySize.length > 0 ) {
				colorItemEls = filteredBySize;
			}
		}

		// Search for the first item, that matches our color and is in stock.
		const foundItemEl = colorItemEls.find( itemEl => {
			const stock = parseInt( itemEl.dataset.stock || 0 );
			return stock > 0;
		} );

		// Return the item, if found.
		if ( foundItemEl ) {
			return foundItemEl;
		}

		// Return the first item, that matches the color we want to have.
		const firstItemEl = colorItemEls.find( () => true );
		if ( firstItemEl ) {
			return firstItemEl;
		}

		// Otherwise just return the first item we have at all.
		return this.articleEl.querySelector( 'input.setitem' );
	}

	/**
     * Set price based on the current variant.
     */
	setPrice = ( colorid = null ) => {
		const currency = getMetaContent( '_isoCurrency' );
		const currencySymbol = getMetaContent( '_currency' );
		const currency_country_code = getMetaContent( '_currency_country_code' );
		const formatter = new Intl.NumberFormat( currency_country_code, {
			style: 'currency',
			currency: currency,
			minimumFractionDigits: 2
		} )

		const currentItemEl = this.getItemByColorId( colorid );
		if ( ! currentItemEl ) {
			return false;
		}

		// So this does not break the other products, if no item was found.
		try {

			const listprice = parseFloat( currentItemEl.getAttribute( 'data-list-price' ) );
			const offerprice = parseFloat( currentItemEl.getAttribute( 'data-offer-price' ) );

			const listpriceFormatted = formatter.format( listprice ).replace( currencySymbol,'' ).trim();
			const offerpriceFormatted = formatter.format( offerprice ).replace( currencySymbol,'' ).trim();

			const priceWrapperEl = this.articleEl.querySelector( '.article_price_wrapper' );
			const uvpPriceEl = this.articleEl.querySelector( '.en_price_uvp' );
			const priceEls = priceWrapperEl.querySelectorAll( '.en_price' );

			const isPriceReduced = listprice > offerprice;
			if ( uvpPriceEl ) {
				uvpPriceEl.classList.toggle( 'en_hidden', ! isPriceReduced );
			}

			priceEls.forEach( ( priceEl ) => {
				const isOldPrice = priceEl.classList.contains( 'en_price--old' );
				const isNewPrice = priceEl.classList.contains( 'en_price--new' );

				//todo seems hideous to do it like that
				if ( isPriceReduced ) {
					if ( isOldPrice ) {
						priceEl.classList.remove( 'en_hidden' );
						priceEl.innerHTML = listpriceFormatted;
					}
					if ( isNewPrice ) {
						priceEl.classList.remove( 'en_hidden' );
						priceEl.innerHTML = offerpriceFormatted;
					}
					if ( !isNewPrice && !isOldPrice ) {
						priceEl.classList.add( 'en_hidden' );
						priceEl.innerHTML = offerpriceFormatted;
					}
				} else {
					if ( isOldPrice ) {
						priceEl.classList.add( 'en_hidden' );
					}
					if ( isNewPrice ) {
						priceEl.classList.add( 'en_hidden' );
					}

					if ( !isNewPrice && !isOldPrice ) {
						priceEl.classList.remove( 'en_hidden' );
						priceEl.innerHTML = offerpriceFormatted;
					}
				}
			} );

			this.updatePrice( offerprice );

		} catch ( error ) {
			console.error( error );
		}
	}

	/**
     * Set Button href, Link, Image and combined Price.
     */
	setResult = () => {

		// Get currently selected item.
		const itemEl = this.getArticleItem();

		// All Elements that link to the article.
		const linkEls = this.articleEl.querySelectorAll( '.style-thumb-link, .article_name' );

		// Set all items as invalid.
		this.itemEls.forEach( itemEl => {
			itemEl.value = 0;
		} );

		// if whole variant chosen with color & size.
		if ( itemEl ) {

			// Mark item as selected.
			itemEl.value = '1';

			// Set Link values.
			linkEls.forEach( linkEl => {
				linkEl.setAttribute( 'href', itemEl.getAttribute( 'data-acl-style-link' ) );
			} );

			// Remove error classes.
			this.articleEl.classList.remove( 'has_error', 'row_has_message', 'mdl_article_preview--in_cart' );

			// Set Button Text.
			if ( this.buttonEl ) {
				this.buttonEl.disabled = false;
				this.buttonEl.innerText = 'In den Warenkorb';
				this.buttonEl.closest( '.input_row' ).removeAttribute( 'data-notification' );
			}
		}

		const currentItemEl = this.getItemByColorId();
		if ( currentItemEl ) {
			const stock = parseInt( currentItemEl.dataset.stock || 0 );
			this.articleEl.querySelectorAll( '[data-visible-if]' ).forEach( toggleEl => {
				switch ( toggleEl.dataset.visibleIf ) {
					case 'out-of-stock':
						toggleEl.classList.toggle( 'en_hidden', stock > 0 );
						break;

					case 'in-stock':
						toggleEl.classList.toggle( 'en_hidden', stock <= 0 );
						break;
				}
			} );

			// Set context for carousel in popup.
			if ( this.popupEl && currentItemEl.dataset.item ) {
				const carouselEl = this.popupEl.querySelector( '.mdl_productcarousel' );
				if ( carouselEl ) {
					carouselEl.dataset.context = currentItemEl.dataset.item;
				}
			}
		}

		return this;
	};

	/**
     * Add the current Article to Basket.
     */
	 addToBasket = async() => {

		const itemEl = this.getArticleItem();
		const inputRowEl = this.buttonEl.closest( '.input_row' );

		if ( ! itemEl ) {
			this.articleEl.classList.add( 'has_error', 'row_has_message' );
			return false;
		}

		// Get Item ID from the Product.
		const itemId = itemEl.dataset.item;

		// Add a loading icon while the server processes the request.
		inputRowEl.setAttribute( 'data-notification', 'loading' );

		// Async function should return a Promise.
		return await MiniBasket.addArticleBySku( itemId ).then( res => {

			// Update Button and Notifications.
			this.articleEl.classList.add( 'mdl_article_preview--in_cart' );
			this.buttonEl.innerText = 'Hinzugefügt'; // in production code do not hard code this
			this.buttonEl.disabled = true;

			inputRowEl.setAttribute( 'data-notification', 'success' );
			return res;
		} ).catch( ( error ) => {

			// Add Error if request fails.
			inputRowEl.setAttribute( 'data-notification', 'error' );
			console.error( error );

			// Toast message, if possible.
			if ( error && Array.isArray( error.error ) ) {
				error.error.forEach( ( {message} ) => {
					if ( message ) {
						const TAO_KOE = window.TAO_KOE;
						if ( TAO_KOE && TAO_KOE.Toaster ) {
							TAO_KOE.Toaster.toast( message, 'error' );
						}
					}
				} )
			}

		} ).finally( ( res ) => {

			// We hide detail message only on Styles&Looks list page.
			const basketFormEl = document.getElementById( 'articletobasketform' );

			// Show the Page Messages on the Details Page.
			if ( basketFormEl ) {
				if ( 'triggerDetailPageMessages' in window ) {
					window.triggerDetailPageMessages();
				}
			}

			return res;
		} );
	}
}


const checkColor = ( labelEl ) => {
	const inputEl = document.getElementById( labelEl.htmlFor );
	if ( inputEl ) {
		inputEl.checked = true;
	}
};

/**
 * Static function to initialise StylesAndLooks Logic on the given Selector.
 */
StylesAndLooks.initStylesAndLooksLogic = ( containerEl ) => {

	// Sanity check.
	if ( ! containerEl ) {
		return null;
	}

	// This whole loop won't be needed if only HTML had the correct values.
	const articleEls = containerEl.querySelectorAll( '.mdl_article_preview' );
	articleEls.forEach( articleEl => {

		// Set Colors.
		const colorLabelEl = articleEl.querySelector( '.colorlabel.status' );
		if ( colorLabelEl ) {
			checkColor( colorLabelEl );
		}

		// Set Metadata for the Article Variants.
		articleEl.querySelectorAll( 'input.setitem' ).forEach( itemEl => {
			const styleId = itemEl.getAttribute( 'id' ).split( '_' );

			if ( ! itemEl.getAttribute( 'data-color' ) ) {
				itemEl.dataset.color = styleId[1] + '_' + styleId[2];
			}

			if ( ! itemEl.getAttribute( 'data-size' ) ) {
				itemEl.dataset.size = '' + styleId[3];
			}

			if ( ! itemEl.getAttribute( 'data-item' ) ) {
				itemEl.dataset.item = styleId[4];
			}

			if ( ! itemEl.getAttribute( 'data-stock' ) ) {
				itemEl.dataset.item = styleId[5];
			}
		} );

		// Add PictureID to the matching colors.
		articleEl.querySelectorAll( '.colorlabel' ).forEach( labelEl => {
			if ( ! labelEl.getAttribute( 'data-picid' ) ) {
				const labelId = labelEl.getAttribute( 'id' ).split( '_' );
				labelEl.parentElement.querySelectorAll( 'input[type="radio"]' ).forEach( inputEl => {
					inputEl.setAttribute( 'data-picid', 'pic_' + labelId[1] + '_' + labelId[2] );
				} )
			}
		} );
	} );

	// Pre-select correct Outfit articles, if available.
	// Previously: selectCorrectOutfitArticles()
	const outfitArticleEl = document.querySelector( 'input[name="outfitArticles"]' );
	if ( outfitArticleEl ) {
		const articles = outfitArticleEl.value.split( ',' );
		const inputEls = Array.from( document.querySelectorAll( 'input.radio.color' ) );
		articles.forEach( articleVariant => {
			const foundInputEls = inputEls.filter( inputEl => inputEl.value.endsWith( articleVariant ) );
			if ( foundInputEls.length > 0 ) {
				foundInputEls.forEach( inputEl => {
					checkColor( inputEl.nextElementSibling );
				} )
			}
		} );
	}

	// Initialise Styles and Looks.
	containerEl.ACL_STYLES_AND_LOOKS ??= new StylesAndLooks( containerEl );
	containerEl.ACL_STYLES_AND_LOOKS.refresh();
	return containerEl.ACL_STYLES_AND_LOOKS;
}

whenReady.then( () => {

	// Styles & Looks Pages count as Listpages for some reason.
	const v_cl = getViewControllerName();

	switch ( v_cl ) {
		case 'alist':
		case 'searchservice_alist_filter':
			StylesAndLooks.initStylesAndLooksLogic( document.getElementById( 'styleslooks_detail' ) );
			break;
	}
} );

window.StylesAndLooks = StylesAndLooks;
window.StylesAndLooksArticle = StylesAndLooksArticle;

export {
	StylesAndLooks,
	StylesAndLooksArticle
};
